import { defineStore } from 'pinia';
import { useSessionStore } from '@/store/session';
import { isBookedServiceStatus, isSettledServiceStatus } from '@/utilities/serviceStatus';

export const useAdhocPaymentStore = defineStore('adhoc_payment', () => {
    const sessionStore = useSessionStore();

    const getItems = computed(() => {
        return (sessionStore?.order?.items || []).filter((item) => item.productable_type === 'adhoc_payment');
    });

    const exists = computed(() => getItems.value.length > 0);

    const getItem = computed(() => {
        return getItems.value[0] ?? null;
    });

    const getProduct = computed(() => {
        return getItem.value?.product ?? null;
    });

    const canRemove = computed(() => false);

    const isConfirmed = computed(() => getItem.value?.status === 'CONFIRMED');

    const canIndividuallyBook = computed(() => {
        return getProduct.value?.status === 'QUOTED';
    });

    const getPaidButtonCopy = computed(() => {
        if (!isConfirmed.value) {
            return null;
        }

        const status = getProduct.value?.status;

        // An ad-hoc payment can also carry the payment-side 'PAID', which is not a ServiceStatus.
        if (isSettledServiceStatus(status) || status === 'PAID') {
            return 'Paid';
        }

        // A booked service is confirmed and scheduled but not necessarily paid.
        if (isBookedServiceStatus(status)) {
            return 'Booked';
        }

        return 'Pending';
    });

    const hasFailedConfirmationPayment = computed(() => {
        return getProduct.value?.confirmation_payment?.status == 'FAILED';
    });

    return {
        exists,
        getItems,
        getItem,
        getProduct,
        canRemove,
        isConfirmed,
        canIndividuallyBook,
        getPaidButtonCopy,
        hasFailedConfirmationPayment,
    };
});
